import React from 'react';
import './HomeRow.css'; // Import CSS file for styling

const ImageRow = () => {
  const images = [
    {
      src: 'images/home_img/hospital.jpg',
      alt: 'Image 1',
      title:'Hospitals & Clinics',
      description: 'They take care of our health while We take care of the Hygiene',
    },
    {
      src: 'images/home_img/student.png',
      alt: 'Image 2',
      title:'Schools & Colleges',

      description: 'Let\'s educate the GenZ with a cool swag of Technology with Untouched.',
    },
    {
      src: 'images/home_img/restaurant.jpg',
      alt: 'Image 3',
      title:'Restaurants & Cafes',

      description: 'Of Course yes! Why compromise with cleansing and cravings?',
    },
    {
      src: 'images/home_img/gym.jpg',
      alt: 'Image 3',
      title:'Gym & Fitness Center',

      description: 'A classy way to organize the customer shopping experience in a digital era.',
    },
  ];

  return (

    <div className="image-row">
      {images.map((image, index) => (
        <div className="image-container" key={index}>
          <img src={image.src} alt={image.alt} />
          <h3 className='image-title'>{image.title}</h3>
          <p className='image-description'>{image.description}</p>
        </div>
      ))}
    </div>
  );
};

export default ImageRow;
